import React from 'react';
import {injectIntl} from 'react-intl';
import {dataValidator} from 'dataValidator';
import Joi from '@hapi/joi';

const EmailFieldValidated = ({intl, settings, onChange, rest}) => {
  const {
    label,
    labelHidden,
    name,
    placeholder,
    state,
    errors,
    setErrors,
    required = true,
    disabled = false,
    hidden = false,
    description = false,
    divClasses = '',
  } = settings || {};
  const baseClasses = `form-group form-group--${name}`;

  if (hidden) {
    return '';
  }

  const validationSchema = Joi.object().keys({
    email: Joi.string()
        .pattern(/^\w+([-+_.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
        .lowercase()
        .required(),
  });

  validationSchema.errorOverrides = {
    email: {
      'string.empty': intl.formatMessage({id: 'JobAlertsForm.EmailFieldRequired'}),
      'any.required': intl.formatMessage({id: 'JobAlertsForm.EmailFieldRequired'}),
      'string.pattern.base': intl.formatMessage({id: 'JobAlertsForm.EmailFieldInvalid'}),
    },
  };

  const handleChange = (event) => {
    event.persist();
    if (required) {
      // Validate email on front end.
      const formErrors = dataValidator(
          {
            [name]: event.target.value,
          },
          validationSchema,
      );
      if (formErrors) {
        setErrors((prev) => {
          if (!prev) {
            return formErrors;
          }
          return {
            ...prev,
            ...formErrors,
          };
        });
      } else {
        setErrors((prev) => {
          if (prev && prev[name]) {
            delete prev[name];
          }

          return prev;
        });
      }
    }

    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  return (
    <div className={`${baseClasses} ${errors && errors[name] ? 'form-group--error' : ''} ${divClasses ? `${divClasses}` : ''}`} >
      {label &&
      <label className={`form-group__label ${labelHidden ? 'hidden--visually' : ''}`} htmlFor={name}>
        {intl.formatMessage({id: label})}
      </label>
      }
      <input
        type="text"
        name={name}
        placeholder={placeholder ? intl.formatMessage({id: placeholder}) : ''}
        required={required}
        disabled={disabled}
        onChange={handleChange}
        value={state && state[name] ? state[name] : ''}
        {...rest}
      />
      {description && <div className="form-group__message">{description}</div>}
      {errors && errors[name] && <div className="form-group__feedback">{ errors[name] }</div>}
    </div>
  );
};

export default injectIntl(EmailFieldValidated);
